<template>
  <div class="forget">
    <p>重置密码</p>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             status-icon>
      <ul class="login-ul">
        <li class="login-li radius3">
          <el-form-item prop="userName" label="用户名：">
            <el-input v-model="dataForm.userName" placeholder="请输入账号"></el-input>
          </el-form-item>
        </li>
        <li class="captcha-box">
          <el-form-item prop="message" label="短信验证码：">
            <el-row :gutter="20">
              <el-col :span="14">
                <el-input v-model="dataForm.message" placeholder="验证码">
                </el-input>
              </el-col>
              <el-col :span="7" class="login-captcha">
                <span href="" class="message-btn">获取验证码</span>
              </el-col>
            </el-row>
          </el-form-item>
        </li>
        <li class="login-li radius3">
          <el-form-item prop="password" label="新密码：">
            <el-input v-model="dataForm.password" type="password" placeholder="请输入密码" autocomplete="off"></el-input>
          </el-form-item>
        </li>
        <li class="login-li radius3">
          <el-form-item prop="againPassword" label="重复密码：">
            <el-input v-model="dataForm.againPassword" type="password" placeholder="请再次输入密码" autocomplete="off"></el-input>
          </el-form-item>
        </li>
        <li class="获取-box">
          <el-form-item prop="captcha" label="验证码：">
            <el-row :gutter="20">
              <el-col :span="14">
                <el-input v-model="dataForm.captcha" placeholder="请输入验证码">
                </el-input>
              </el-col>
              <el-col :span="12" class="login-captcha">
                <img :src="captchaPath" @click="getCaptcha()" alt="">
              </el-col>
            </el-row>
          </el-form-item>
        </li>
        <li>
          <router-link to="/login"><span class="blue-back">返回登录</span></router-link>
        </li>
        <li class="btn-li">
          <el-form-item>
            <el-button class="login-btn radius3" style="padding: 0px 0px;" type="primary"
                       @click="dataFormSubmit()">立即重置
            </el-button>
          </el-form-item>
        </li>
      </ul>
    </el-form>
  </div>
</template>
<script>
  import {getUUID} from '@/utils'
  import axios from 'axios'

  const  ssoHttp = axios.create({
    timeout: 1000 * 30,
    withCredentials: true,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X_PROXY_GATEWAY':true,
      'Content-Type': 'application/json; charset=utf-8'
    }
  })

  export default {
    data () {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.dataForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dataForm: {
          userName: '',
          password: '',
          againPassword:'',
          uuid: '',
          captcha: '',
          message:''
        },
        dataRule: {
          userName: [
            {required: true, message: '帐号不能为空', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '密码不能为空', trigger: 'blur'}
          ],
          againPassword: [
            {validator: validatePass, trigger: 'blur'}
          ],
          message: [
            {required: true, message: '短信验证码不能为空', trigger: 'blur'}
          ],
          captcha: [
            {required: true, message: '验证码不能为空', trigger: 'blur'}
          ]
        },
        captchaPath: ''
      }
    },
    created () {
      this.getCaptcha()
    },
    methods: {
      // 提交表单
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            ssoHttp.post( ssoBaseUrl + '/singleLogin',{
              'backUrl': '',
              'loginType': 0,
              'useCaptcha': 1,
              'appCode': window.SITE_CONFIG.appCode,
              'username': this.dataForm.userName,
              'password': this.dataForm.password,
              'uuid': this.dataForm.uuid,
              'captcha': this.dataForm.captcha,
              'message': this.dataForm.message
            }).then(({data}) => {
              if (data && data.code === '1') {
                    this.$cookie.set('access_token', data.authCode)
                    this.$cookie.set('oauth_access_token', data.authCode);
                    this.$router.replace({ name: 'home' })
              } else {
                this.getCaptcha()
                this.$message.error(data.msg)
              }
            })
          }
        })
      },
      // 获取验证码
      getCaptcha () {
        this.dataForm.uuid = getUUID()
        this.captchaPath = process.env.VUE_APP_proxybaseurl + `/api/captchaCode.png?uuid=${this.dataForm.uuid}`
      }
    }
  }
</script>

